import { GatewayChannelWithChargePointInfoModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-channel-with-charge-point-info.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { ChannelListLastMessageReceivedDateCell } from './channel-list-last-message-received-date.cell';
import { ChannelListLastMessageReceivedDateHeader } from './channel-list-last-message-received-date.header';

export const ChannelListLastMessageReceivedDateColumn: IdentifiedColumnDef<
  GatewayChannelWithChargePointInfoModel,
  GatewayChannelWithChargePointInfoModel['lastMessageReceivedDate']
> = {
  enableSorting: false,
  header: ChannelListLastMessageReceivedDateHeader,
  cell: ChannelListLastMessageReceivedDateCell,
};
